export default "__VITE_ASSET__Cyogy8U$__"